import { render, staticRenderFns } from "./category-list.vue?vue&type=template&id=b1b73a38&scoped=true"
import script from "./category-list.vue?vue&type=script&lang=js"
export * from "./category-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b73a38",
  null
  
)

export default component.exports